import { createSelector } from 'reselect';
import * as root from '../';
import * as fromFinalApproverRequest from './final-approver-request.reducer';

export const getFinalApproverRequestState = (state: root.State) => state.finalApproverRequest;

export const getAllFinalApproverRequests = createSelector(getFinalApproverRequestState, fromFinalApproverRequest.getAll);

export const getFinalApproverRequestSaving = createSelector(getFinalApproverRequestState, fromFinalApproverRequest.getSaving);
